<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>M201 匯出授權名單-查詢條件</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td>查調日期</td>
                <td>
                  <select v-model="form.authOpenDate" style="min-width: 480px">
                    <option
                      v-for="(item, index) in dropDownList.onAuthOpen"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  申報人總人數: {{ Count.authCount }} 含眷屬總人數:
                  {{ Count.familyAuthCount }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="f_center">
                  <input
                    type="submit"
                    class="btn"
                    value="匯出查詢名單"
                    @click="doPrintAuthDetail()"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="匯出派查檔"
                    @click="doPrintAuth()"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
    <CyFooter />
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import {
  M201_SearchAuthOpen,
  M201_PrintAuth,
  M201_PrintAuthDetail,
  M201_CountAuth,
} from "@/service/api.js";

export default {
  name: "M201",
  data: function () {
    return {
      pageData: {
        MenuIndex: 2,
        PrgName: "M201",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        authOpenDate: "",
        pagesize: 10,
        currentpage: 1,
      },
      grid: { gridDatas: [], paginaiton: [] },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      Count: {
        authCount: 0,
        familyAuthCount: 0,
      },
      dropDownList: {
        onAuthOpen: [],
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
  },
  methods: {
    doPrintAuth: function () {
      const self = this;
      let postData = {
        authopendate: self.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "匯出派查檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };

      M201_PrintAuth(postData).then((rData) => {
        if (rData == "") {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["未有資料"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
          };
        } else {
          let link = document.createElement("a");
          link.download = "派查檔名單";
          link.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            rData;
          link.click();
        }
      });
    },
    doPrintAuthDetail: function () {
      const self = this;
      let postData = {
        authopendate: self.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "匯出查詢名單",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M201_PrintAuthDetail(postData).then((rData) => {
        if (rData == "") {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["未有資料"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
          };
          return;
        } else {
          let link = document.createElement("a");
          link.download = "匯出查調名單";
          link.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            rData;
          link.click();
        }
      });
    },
    getOnAuthOpen: function () {
      const self = this;
      M201_SearchAuthOpen().then((rData) => {
        self.dropDownList.onAuthOpen = rData.returnObject;
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.getOnAuthOpen();
  },
  watch: {
    "form.authOpenDate": function (newValue, oldValue) {
      var self = this;
      if (newValue != oldValue) {
        debugger;
        M201_CountAuth({
          authopendate: newValue,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "查授權人數",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        }).then((rData) => {
          if (rData.result) {
            this.Count = rData.returnObject;
          }
        });
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
